import {
  Fragment,
} from 'react';
import classNames from 'classnames';
import {
  usePageContext,
} from 'vike-react/usePageContext';
import TestingAccessModal from '@/components/Modals/TestingAccessModal';
import {
  IOS_URL,
  EXTENSION_URL,
} from '@/constants';
import useModal from '@/hooks/useModal';
import Button from '@/ui/components/Button';
import Text from '@/ui/components/Text';
import type {
  TextProps,
} from '@/ui/components/Text';
import {
  StarIcon,
} from '@/ui/icons';

import styles from './InstallButton.module.css';

type InstallButtonProps = {
  color?: TextProps['color'],
  kind?: 'default' | 'inline';
  withRating?: boolean;
}

const InstallButton = (props: InstallButtonProps) => {
  // ##########################################################################
  // PARAMS
  // ##########################################################################

  const {
    platform,
  } = usePageContext();

  // ##########################################################################
  // PROPS
  // ##########################################################################

  const {
    color = 'neutral-600',
    kind = 'default',
    withRating = false,
  } = props;

  // ##########################################################################
  // STATE
  // ##########################################################################

  const testingAccessModal = useModal();

  // ##########################################################################
  // CONSTANTS
  // ##########################################################################

  const stars = Array.from({ length: 5 });

  // ##########################################################################
  // COMPUTED STYLES
  // ##########################################################################

  const installButtonClassName = classNames({
    [styles.installButton]: true,
    [styles.inline]: kind === 'inline',
  });

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <Fragment>
      <TestingAccessModal {...testingAccessModal} />

      <div className={installButtonClassName}>
        <a
          href={EXTENSION_URL}
          className={styles.extension}
          target="_blank"
          rel="noopener noreferrer"
        >
          Get Dinosave for free
        </a>

        {platform === 'ios' && (
          <a
            href={IOS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.appStore}
          >
            <Button color="secondary">
              <img src="/images/appstores/ios.svg" />
            </Button>
          </a>
        )}

        {platform === 'android' && (
          <div className={styles.appStore}>
            <Button
              color="secondary"
              onClick={testingAccessModal.toggle}
            >
              <img src="/images/appstores/android.svg" />
            </Button>
          </div>
        )}

        {withRating && (
          <div className={styles.rating}>
            <div className={styles.stars}>
              {stars.map((_, index) => (
                <StarIcon key={index} />
              ))}
            </div>

            <div className={styles.ratingText}>
              <Text
                kind="heading-6"
                color={color}
                weight="500"
              >
                5,0
                <span className={styles.divider} />
                100+ Users
              </Text>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default InstallButton;
